"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInitialRewardQuery = void 0;
const react_query_1 = require("@tanstack/react-query");
const useDareDropApi_1 = require("root/src/client/v2/common/hooks/useDareDropApi");
const constants_1 = require("root/src/shared/rewards/constants");
function useInitialRewardQuery(dropId, params) {
    const { fetcher } = (0, useDareDropApi_1.useDareDropApi)();
    return (0, react_query_1.useQuery)(Object.assign(Object.assign({}, params), { queryKey: ['GET_INITIAL_REWARD'], queryFn: () => __awaiter(this, void 0, void 0, function* () {
            return fetcher({
                endpointId: constants_1.RewardEndpoint.GET_INITIAL_REWARD,
                payload: { campaignId: dropId },
            }, true);
        }) }));
}
exports.useInitialRewardQuery = useInitialRewardQuery;
